module.exports = "/_next/static/images/500-5ecf6f8ebc81f3140f303be09eeac70e.png";